/**
 * @desc 账号登录
 */
import { LoginResult, LoginPasswordForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginMemberByPasswordParameter = LoginPasswordForm

const method = 'POST'
const url = '/auth/member/login/password'

export const loginMemberByPasswordApi = (
  data?: LoginMemberByPasswordParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    data,
    ...config
  })
}

loginMemberByPasswordApi.method = method
loginMemberByPasswordApi.url = url
